import {
    createOptionPicker,
    IOptionPickerItem,
    OptionPicker,
    OptionPickerType,
} from '@vfde-brix/ws10/option-picker';

/**
 * Mount the option picker
 */
const mountOptionPicker = (
    containerId: string,
    stdName: string,
    optType: OptionPickerType,
    items: IOptionPickerItem[],
    onChange: (Event: Event) => void,
): OptionPicker | null => {
    const container = document.getElementById(containerId);

    /* istanbul ignore next */
    if (!container) {
        return null;
    }

    return createOptionPicker(container, {
        stdName,
        optType,
        items,
        business: {
            onChange,
        },
    });
};

export default mountOptionPicker;
